import { DefaultRootState } from 'react-redux';

export const selectResumeSuitableVacancy = ({
    applicantResume,
    applicantSuitableVacancyByResume,
}: DefaultRootState): number => {
    const hash = applicantResume._attributes.hash;
    return applicantSuitableVacancyByResume[hash];
};
